import React from 'react';
import PropTypes from 'prop-types';

import { LocaleString } from '@biw/intl';


const UserDetais = ( { firstName, lastName, userName, emailAddress } ) => (
    <div className="user-details">
    <div className="username client-primary-text">
        { firstName }<br />
        { lastName }
    </div>
    <div className="user-id">
        <LocaleString TextComponent="div" className="user-info-label client-primary-text" code='common.userIdLabel' />
        { userName }
    </div>
    <div className="email-address">
        <LocaleString TextComponent="div" className="user-info-label client-primary-text" code='profile.emailAddressLabel' />
        { emailAddress }
    </div>
</div>
);

UserDetais.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    userName: PropTypes.string,
    emailAddress: PropTypes.string
};

export default UserDetais;
